/**
 * @file index.stories.tsx
 *
 * @fileoverview Used for responsive images where mobile and desktop
 * will have different files
 */
import styles from "./picture.module.scss";

export interface PictureProps {
  /**
   * Landscape image source.
   */
  landscapeSrc: string;
  /**
   * Portrait image source.
   */
  portraitSrc?: string;
  /**
   * Alternative text for the image.
   */
  alt: string;
  /**
   * Title for the image.
   */
  title: string;
}

/**
 * Displays a responsive picture element with responsive images inside
 * for landscape and portrait orientations.
 */
export default function Picture({
  landscapeSrc,
  portraitSrc,
  alt,
}: PictureProps) {
  return (
    <picture>
      {portraitSrc && (
        <source media="(max-width: 768px)" srcSet={portraitSrc} />
      )}
      <img className={styles.image} src={landscapeSrc} alt={alt} />
    </picture>
  );
}

export { Picture };
